export const formErrorsToObject = (xs) => {
    return Object.fromEntries(xs.map((x) => [x.field, x.message]));
};
